module.exports = __webpack_public_path__ + "newsletter/Components/PocketHitsSignup/images/publishers/logo-saveur.b8f157917ff7e05dc121a97178ce1d0a.png";